import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/dialog/dialog'

import { cn } from '@/lib/utils'

export interface DuplicatedRowsDialogProps {
  isOpen: boolean
  duplicatedCaseNumbers: string[]
  close: VoidFunction
}

export const DuplicatedRowsDialog = ({ isOpen, duplicatedCaseNumbers, close }: DuplicatedRowsDialogProps) => {
  const isPlural = duplicatedCaseNumbers.length > 1

  const handleChangeOpen = (open: boolean) => {
    if (!open) {
      close()
      return
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={handleChangeOpen}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Duplicated Case {isPlural ? 'Numbers' : 'Number'}</DialogTitle>
          <DialogDescription className={cn('sr-only')}>
            This dialog provides additional information about duplicated rows.
          </DialogDescription>
        </DialogHeader>

        <ul className={cn('list-inside list-disc', 'flex flex-col', 'w-fit', 'pl-1')}>
          {duplicatedCaseNumbers.map((caseNumber, index) => (
            <li key={`${caseNumber}-${index}`} className={cn('py-0.5')}>
              {caseNumber}
            </li>
          ))}
        </ul>
      </DialogContent>
    </Dialog>
  )
}
